module.exports = __webpack_public_path__ + "img/event_meet_up_4_0.341215dc.png";